/*
* src/store/modules/login.js
* Login Conatiner의 redux type, action, reducer 정의
*/
import { fromJS } from 'immutable';

// constants 정의
export const SET_LOGIN = 'login/SET_LOGIN';
export const GET_AUTH = 'login/GET_AUTH';
export const CREATE_USER = 'login/CREATE_USER';
export const REQUEST_SUCCESS = 'login/REQUEST_SUCCESS';

export const setLogin = () => {
    return {
        type: SET_LOGIN
    };
}

export const getAuth = (user) => {
    return {
        type: GET_AUTH,
        user: user
    };
}

export const requestSuccess = () => {
    return {
        type: REQUEST_SUCCESS
    }
}

// 초기 상태
const initialState = fromJS({
    loading: false,
    user: fromJS({
        identity: false,
        password: false,
        name: false
    }),
});

// Login reducer
export default function loginReducer(state = initialState, action) {
    switch (action.type) {
        case SET_LOGIN:
            return initialState;
        case GET_AUTH:
            return state
                .set('loading', false)
                .setIn(['user', 'identity'], action.user.identity)
                .setIn(['user', 'password'], action.user.password);
        case REQUEST_SUCCESS:
            return state
                .set('loading', true);
        default:
            return state;
    }
}